import * as T99FrontUtils from './utils/frontEndUtils';

import { gsap } from "gsap";
import SplitText from "gsap/SplitText";
import ScrollTrigger from "gsap/ScrollTrigger";
import CustomEase from "gsap/CustomEase";
import Lenis from 'lenis'
import Ukiyo from "ukiyojs";
import Swiper from 'swiper';


/**
 * UTILS
 * 
 */
T99FrontUtils.columnLinkFront(); // Agginge link alle colonne
T99FrontUtils.browserDetection(); // Rilevamento del browser e dispositivo
T99FrontUtils.checkLoadEvents(); // Verifica gli eventi di caricamento


gsap.registerPlugin(SplitText, ScrollTrigger, CustomEase);
gsap.config({ nullTargetWarn: false, force3D: true });
CustomEase.create("custom-ease", "M0,0,C0.126,0.382,0.282,0.674,0.44,0.822,0.632,1.002,0.818,1.001,1,1");

// SMOOTH SCROLL 
const lenis = new Lenis();


lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 850);
});

gsap.ticker.lagSmoothing(0);


T99FrontUtils.scrollBody(lenis); // Aggiunge la classe body secondo lo scroll




/*
-------------------------------------------------------------------
THEME INIT 
-------------------------------------------------------------------
*/
function init() {
  headerInit();
  tooltipCursorInit();
  pagePreloaderInit();


  animationTitlesL();
  animationTitlesXL();
  animationTitlesXXL();
  animationTextHeroHomepage();
  animationParagraphsHero();
  animationTitlesMakeAReservation();
  animationPetternImages();
  animationElementiParallax();

  initUkiyoParallax();

  sliderQueryPosts();
  patternGridServices();


  changeFooterBorderRadius();

}




if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}



function headerInit() {
  const header = document.querySelector('.wp-site-blocks > header');
  const overlay = header.querySelector('#overlay');
  const closeButton = overlay.querySelector('.close-menu');


  if (!header || !overlay || !closeButton) return;

  const toggle = header.querySelector('.menu-toggle');
  if (!toggle) return;

  toggle.addEventListener('click', () => {
    document.body.classList.toggle('menu-open');
    toggle.classList.toggle('active');
    gestisciStatoLenis();

    if (document.body.classList.contains('menu-open')) {
      animateOverlayImage(overlay);
    }
  });

  closeButton.addEventListener('click', () => {
    document.body.classList.remove('menu-open');
    toggle.classList.remove('active');
    gestisciStatoLenis();

    setTimeout(() => {
      const overlayNavMenu = overlay.querySelector('.overlay__container-menu .menu');
      if (overlayNavMenu) {
        overlayNavMenu.classList.remove('submenu-active');
        overlayNavMenu.querySelectorAll('.menu-item.submenu-open').forEach(openItem => {
          openItem.classList.remove('submenu-open');
        });
      }
    }, 600);
  });

  function subMenu() {
    const overlayNavMenu = overlay.querySelector('.overlay__container-menu .menu');
    if (!overlayNavMenu) return;

    const menuItems = overlayNavMenu.querySelectorAll('.menu-item-has-children > a');

    menuItems.forEach(item => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        const parentLi = item.parentElement;

        overlayNavMenu.querySelectorAll('.menu-item.submenu-open').forEach(openItem => {
          if (openItem !== parentLi) {
            openItem.classList.remove('submenu-open');
          }
        });

        parentLi.classList.toggle('submenu-open');

        const hasOpenSubmenu = overlayNavMenu.querySelector('.menu-item.submenu-open');
        if (hasOpenSubmenu) {
          overlayNavMenu.classList.add('submenu-active');
        } else {
          overlayNavMenu.classList.remove('submenu-active');
        }
      });
    });

    const subMenus = overlayNavMenu.querySelectorAll('.sub-menu');
    subMenus.forEach(subMenu => {

      const backButton = document.createElement('li');
      backButton.className = 'menu-item menu-item-back';
      backButton.innerHTML = '<a href="#">Back</a>';
      subMenu.insertBefore(backButton, subMenu.firstChild);

      backButton.addEventListener('click', (e) => {
        e.preventDefault();
        const parentMenuItem = subMenu.closest('.menu-item-has-children');
        parentMenuItem.classList.remove('submenu-open');
        overlayNavMenu.classList.remove('submenu-active');
      });
    });

  }

  subMenu();

  function changeImageOnMenuHover() {
    const imageCovers = overlay.querySelectorAll('.overlay__container-images .wp-block-cover');
    const menuItems = overlay.querySelectorAll('.overlay__container-menu .menu-item:not(.menu-item-back):not(.sub-menu *)');



    menuItems.forEach((item, index) => {
      item.addEventListener('mouseenter', () => {
        imageCovers.forEach((cover, coverIndex) => {
          if (coverIndex === index) {
            cover.classList.add('active');
          } else {
            cover.classList.remove('active');
          }
        });
      });

    });
  }

  changeImageOnMenuHover();

}


function pagePreloaderInit() {
  const overlay = document.getElementById('preloader');
  if (!overlay) return;

  const curtainPath = overlay.querySelector('#preloader-curtain');
  const isMobile = window.innerWidth < 768;

  const curve = isMobile
    ? "M0 502S175 450 500 450s500 52 500 52V0H0Z"
    : "M0 502S175 250 500 250s500 252 500 252V0H0Z";
  const flat = "M0 2S175 1 500 1s500 1 500 1V0H0Z";

  const curveBottom = isMobile
    ? "M0 502S175 550 500 550s500 -48 500 -48V1000H0Z"
    : "M0 502S175 750 500 750s500 -248 500 -248V1000H0Z";
  const flatBottom = "M0 1000S175 1000 500 1000s500 0 500 0V1000H0Z";

  document.body.style.cursor = 'wait';

  // ANIMAZIONE INGRESSO PAGINA
  window.addEventListener('load', () => {

    const tl = gsap.timeline({
      onComplete: () => {
        gsap.set(overlay, { y: -10 });
        document.body.style.cursor = 'default';
      }
    });

    tl.to(curtainPath, {
      duration: 0.6,
      attr: { d: curve },
      ease: "power2.in",
    })
      .to(curtainPath, {
        duration: 0.6,
        attr: { d: flat },
        ease: "power2.out",
      }, "-=0.1")
      .to(overlay, {
        y: -1500,
        duration: 0.8,
        ease: "power2.inOut",
      }, "-=0.2");
  });


  // ANIMAZIONE USCITA PAGINA
  document.body.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (!link) return;

    const href = link.getAttribute('href');
    const isHash = href && (href.startsWith('#') || href === window.location.hash);
    const isExternal = link.host !== window.location.host;
    const isNewTab = link.target && link.target !== '_self';
    const isDownload = link.hasAttribute('download');

    if (!href || isHash || isExternal || isNewTab || isDownload) {
      return;
    }

    e.preventDefault();

    document.body.style.cursor = 'wait';

    if (document.body.classList.contains('menu-open')) {
      document.body.classList.remove('menu-open');
      const toggle = document.querySelector('.menu-toggle');
      if (toggle) {
        toggle.classList.remove('active');
      }
      gestisciStatoLenis();
    }

    gsap.set(overlay, { y: 0, opacity: 1 });
    gsap.set(curtainPath, { attr: { d: flatBottom } });

    const entryContent = document.querySelector('.entry-content');

    const tl = gsap.timeline({
      onComplete: () => {
        window.location.href = href;
      }
    });

    tl.to(curtainPath, {
      duration: 0.5,
      attr: { d: curveBottom },
      ease: "power2.in",
    })
      .to(curtainPath, {
        duration: 0.5,
        attr: { d: "M0 0S175 0 500 0s500 0 500 0V1000H0Z" },
        ease: "power2.out",
      }, "-=0.1");

    if (entryContent) {
      gsap.to(entryContent, {
        y: '-10vh',
        duration: 1.0,
        ease: "power2.inOut",
      });
    }

    // setTimeout(() => {
    //   window.location.href = href;
    // }, 1100);
  });

  window.addEventListener("pageshow", function (evt) {
    if (evt.persisted) {
      setTimeout(function () {
        window.location.reload();
      }, 10);
    }
  }, false);
}


function gestisciStatoLenis() {
  if (document.body.classList.contains('menu-open')) {
    if (!gestisciStatoLenis._stopped) {
      lenis.stop();
      gestisciStatoLenis._stopped = true;
    }
  } else if (gestisciStatoLenis._stopped) {
    lenis.start();
    gestisciStatoLenis._stopped = false;
  }
}


function tooltipCursorInit() {
  const tooltip = document.getElementById('t99-tooltip');
  if (!tooltip) return;

  document.addEventListener('mousemove', (e) => {

    const offsetX = -15;
    const offsetY = -5;
    gsap.to(tooltip, {
      x: e.clientX + offsetX,
      y: e.clientY + offsetY,
      duration: 0.6,
      ease: "power2.out"
    });
  });

  const tooltipElements = document.querySelectorAll('[data-t99-tooltip]');

  tooltipElements.forEach(el => {
    el.addEventListener('mouseenter', () => {
      const content = el.getAttribute('data-t99-tooltip');
      tooltip.querySelector('.t99-tooltip-content').textContent = content;
      tooltip.setAttribute('aria-hidden', 'false');
      gsap.to(tooltip, { scale: 1, duration: 0.3, ease: "power2.out" });
    });

    el.addEventListener('mouseleave', () => {
      tooltip.setAttribute('aria-hidden', 'true');

      gsap.to(tooltip, { scale: 0, duration: 0.3, ease: "power2.out" });
    });
  });
}


function animationTitlesL() {
  const titlesL = gsap.utils.toArray('.wp-block-heading.has-l-font-size:not(.is-style-no-animation):not(.home .hero *), .wp-block-post-title.has-l-font-size:not(.is-style-no-animation)');

  if (titlesL.length === 0) return;

  titlesL.forEach(title => {



    document.fonts.ready.then(() => {
      const split = new SplitText(title, { type: "lines", linesClass: "split-line" });

      gsap.set(split.lines, { opacity: 0 });

      gsap.to(split.lines, {
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        transformOrigin: "left center",
        stagger: 0.1,
        scrollTrigger: {
          trigger: title,
          start: "top 90%",
        }
      });
    });


  });
}

function animationTitlesXL() {
  const titlesXL = gsap.utils.toArray('.wp-block-heading.has-xl-font-size:not(.is-style-no-animation), .wp-block-post-title.has-xl-font-size:not(.is-style-no-animation)');

  if (titlesXL.length === 0) return;

  titlesXL.forEach(title => {
    document.fonts.ready.then(() => {
      const split = new SplitText(title, { type: "lines,chars", mask: "lines" });

      gsap.set(split.chars, { opacity: 0 });
      gsap.to(split.chars, {
        opacity: 1,
        delay: 0.4,
        duration: 2,
        // ease: "custom-ease",
        ease: "power2.inOut",
        stagger: 0.04,
        scrollTrigger: {
          trigger: title,
          start: "top 90%",
        }
      });
    });
  });
}

function animationTitlesXXL() {
  const titlesXXL = gsap.utils.toArray('.wp-block-heading.has-xxl-font-size:not(.is-style-no-animation), .wp-block-post-title.has-xxl-font-size:not(.is-style-no-animation)');

  if (titlesXXL.length === 0) return;

  titlesXXL.forEach(title => {
    document.fonts.ready.then(() => {
      const split = new SplitText(title, { type: "lines,chars", mask: "lines", linesClass: "split-line", charsClass: "split-char" });

      gsap.set(split.chars, { yPercent: 120, rotate: -3 });
      gsap.to(split.chars, {
        yPercent: 0,
        rotate: 0,
        delay: 0.6,
        duration: 1,
        ease: "custom-ease",
        stagger: 0.03,
        scrollTrigger: {
          trigger: title,
          start: "top 90%",
        }
      });
    });
  });
}


function animationTitlesMakeAReservation() {
  const titles = gsap.utils.toArray('.make-a-reservation-text .wp-block-heading');
  if (titles.length === 0) return;

  titles.forEach(title => {
    document.fonts.ready.then(() => {
      const split = new SplitText(title, { type: "chars", charsClass: "split-char" });
      gsap.set(split.chars, { opacity: 0 });

      gsap.to(split.chars, {
        opacity: 1,
        duration: 1.2,
        ease: "power2.inOut",
        stagger: 0.04,
        scrollTrigger: {
          trigger: title,
          start: "top 90%",
        }
      });
    });
  });
}

function animationTextHeroHomepage() {
  const title = document.querySelector('.home .hero .wp-block-heading, .home .pattern__hero .wp-block-heading');
  const paragraph = document.querySelector('.home .hero p, .home .pattern__hero p');

  if (!title || title.classList.contains('is-style-no-animation')) return;

  document.fonts.ready.then(() => {
    const split = new SplitText(title, { type: "lines,chars", mask: "lines" });
    gsap.set(split.chars, { opacity: 0, rotateY: -90 });
    gsap.set(paragraph, { opacity: 0 });

    gsap.to(split.chars, {
      rotateY: 0,
      opacity: 1,
      delay: 0.8,
      duration: 1.2,
      ease: "power2.out",
      stagger: {
        amount: 0.8,
        from: "random"
      },
      scrollTrigger: {
        trigger: title
      },
    });

    gsap.to(paragraph, {
      opacity: 1,
      delay: 1.2,
      duration: 1.2,
      ease: "power1.in",
      scrollTrigger: {
        trigger: paragraph,
      }
    });
  });
}

function animationParagraphsHero() {
  const paragraphs = gsap.utils.toArray('.hero p:not(.is-style-no-animation), .pattern__hero p:not(.is-style-no-animation)');

  if (paragraphs.length === 0) return;
  paragraphs.forEach(paragraph => {

    gsap.set(paragraph, { opacity: 0 });
    gsap.to(paragraph, {
      opacity: 1,
      delay: 0.6,
      duration: 1.2,
      ease: "power2.inOut",
      transformOrigin: "left center",
      stagger: 0.1,
      scrollTrigger: {
        trigger: paragraph,
        start: "top 90%",
      }
    });

  })
}




function animationPetternImages() {
  const patternImages = gsap.utils.toArray(".reveal-animation img");

  patternImages.forEach(img => {

    if (img.closest('#overlay')) {

      gsap.set(img, {
        scale: 1.4,
        opacity: 0,
        maskSize: "0% 0%",
        webkitMaskSize: "0% 0%"
      });
      return;
    }

    gsap.fromTo(img,
      {
        scale: 1.4,
        opacity: 0,
        maskSize: "0% 0%",
        webkitMaskSize: "0% 0%"
      },
      {
        scale: 1,
        opacity: 1,
        maskSize: "200% 200%",
        webkitMaskSize: "200% 200%",
        duration: 1.8,
        ease: "power1.inOut",
        scrollTrigger: {
          trigger: img.closest(".reveal-animation"),
          start: "top bottom%",
        }
      }
    );
  });

}

function animateOverlayImage(overlay) {
  const overlayImage = overlay.querySelector('.reveal-animation img');

  if (!overlayImage) return;

  gsap.fromTo(overlayImage,
    {
      scale: 1.8,
      opacity: 0,
      maskSize: "0% 0%",
      webkitMaskSize: "0% 0%"
    },
    {
      delay: 0.2,
      scale: 1,
      opacity: 1,
      maskSize: "200% 200%",
      webkitMaskSize: "200% 200%",
      duration: 1.8,
      ease: "power1.inOut"
    }
  );
}

function animationElementiParallax() {
  if (window.innerWidth < 781) return;

  const elements = gsap.utils.toArray("[data-scroll]");

  elements.forEach((el) => {
    const speed = parseFloat(el.getAttribute("data-scroll")) || 1;
    const yPercent = (speed - 1) * 70; // 70% 

    gsap.fromTo(el,
      {
        y: -yPercent
      },
      {
        y: yPercent,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true
        }
      }
    );
  });
}

function changeFooterBorderRadius() {
  const footer = document.querySelector('footer.wp-block-template-part .wrapper');
  if (!footer) return;

  const radius = window.innerWidth < 781 ? 25 : 80;

  gsap.to(footer, {
    borderTopLeftRadius: radius,
    borderTopRightRadius: radius,
    scrollTrigger: {
      trigger: footer,
      start: "top bottom",
      end: "top center",
      scrub: true,
    }
  });
}

const ukiyoInstances = [];
let ukiyoTickerAdded = false;

function initUkiyoParallax() {
  const isMobile = window.innerWidth < 1024;
  ukiyoInstances.length = 0;


  const parallaxConfigs = [
    {
      selector: '.wp-block-cover.parallax video.wp-block-cover__video-background, .wp-block-cover.parallax img.wp-block-cover__image-background, .slider-sections-container .swiper-slide-inner.parallax img', // GENERAL
      options: {
        scale: 1.1,
        speed: 1.1,
        willChange: true,
        externalRAF: true
      }
    },
    {
      selector: '.hero .wp-block-cover__video-background, .hero .wp-block-cover__image-background', //HERO
      options: {
        scale: 1.1,
        speed: isMobile ? 2 : 10,
        willChange: true,
        externalRAF: true
      }
    },
    {
      selector: 'footer.wp-block-template-part img.wp-block-cover__image-background', // FOOTER
      options: {
        scale: 1.2,
        speed: 2,
        willChange: true,
        externalRAF: true
      }
    }
  ];

  parallaxConfigs.forEach(config => {
    const elements = document.querySelectorAll(config.selector);
    elements.forEach(element => {
      const instance = new Ukiyo(element, config.options);
      ukiyoInstances.push(instance);
    });
  });

  if (!ukiyoTickerAdded) {
    gsap.ticker.add(() => {
      ukiyoInstances.forEach(instance => instance.animate());
    });
    ukiyoTickerAdded = true;
  }
}


function sliderQueryPosts() {
  const sliderSections = document.querySelectorAll('#QUERY-SLIDER');

  if (sliderSections.length === 0) return;

  sliderSections.forEach(sliderSection => {
    const swiper = sliderSection.querySelector('.wp-block-query');
    const wrapper = sliderSection.querySelector('.wp-block-post-template');
    const singleSlides = wrapper.querySelectorAll('.wp-block-post');
    const navigation = sliderSection.querySelector('.navigation');

    if (singleSlides.length === 0) return;

    swiper.classList.add('swiper');
    swiper.style.overflow = 'visible';

    wrapper.classList.add('swiper-wrapper');
    singleSlides.forEach(slide => {
      slide.classList.add('swiper-slide');
    });

    const nextButton = navigation.querySelector('.next');
    const prevButton = navigation.querySelector('.prev');

    if (nextButton && prevButton) {
      nextButton.addEventListener('click', () => {
        swiperContent.slideNext();
      });
      prevButton.addEventListener('click', () => {
        swiperContent.slidePrev();
      });
    }

    const swiperContent = new Swiper(swiper, {
      speed: 1200,
      slidesPerView: 'auto',
      spaceBetween: 20,
      freeMode: true,
      freeModeSticky: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10,
          freeModeSticky: false,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        }
      },
    });



  });


}

function patternGridServices() {
  const patternGrids = gsap.utils.toArray('.pattern__grid-services');
  if (patternGrids.length === 0) return;

  patternGrids.forEach(grid => {
    const posts = grid.querySelectorAll('.wp-block-post');

    posts.forEach((post, index) => {
      const readMoreLink = post.querySelector('.wp-block-post a');
      if (!readMoreLink) return;

      const href = readMoreLink.getAttribute('href');
      post.style.cursor = 'pointer';

      post.addEventListener('click', (e) => {
        if (e.target.tagName.toLowerCase() === 'a' || e.target.closest('a')) {
          return;
        }
        window.location.href = href;
      });

    })
  });
}